var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "filter-chip-container",
      class: {
        "chip-container--removable": _vm.removable,
        "chip-container--clearable": _vm.clearable,
      },
      attrs: { "data-filter-field": _vm.dataFilterField },
    },
    [
      _c(
        "CustomPopover",
        {
          ref: "customPopover",
          attrs: {
            icon: _vm.icon,
            label: _vm.getLabel(),
            "show-dropdown-arrow": false,
            "button-class":
              _vm.chipClass +
              (_vm.removable ? " chip--removable" : "") +
              (_vm.hasValue ? " chip--has-value" : ""),
            "show-form-footer": true,
            removable: _vm.removable,
            clearable: _vm.isClearable,
          },
          on: {
            "popover-change": _vm.onPopoverChange,
            clear: _vm.onPopoverClear,
            apply: _vm.onPopoverApply,
            "remove-click": _vm.onRemove,
            "clear-click": _vm.onClear,
          },
        },
        [
          _c("template", { slot: "content" }, [
            _c(
              "div",
              { staticClass: "meta-referral-composite-container" },
              [
                _vm._l(_vm.rows, function (row, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "meta-referral-composite-row" },
                    [
                      _c(
                        "div",
                        { staticClass: "meta-referral-composite-row-grid" },
                        [
                          _c(
                            "div",
                            { staticClass: "meta-referral-composite-field" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "meta-referral-composite-label",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t("chat.filtersSection.type")
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: row.selectValue,
                                      expression: "row.selectValue",
                                    },
                                  ],
                                  staticClass: "meta-referral-composite-select",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        row,
                                        "selectValue",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(_vm._s(_vm.$t("auto.select"))),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.fieldOptions, function (option) {
                                    return _c(
                                      "option",
                                      {
                                        key: option.value,
                                        domProps: { value: option.value },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(option.label) +
                                            "\n                                "
                                        ),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "meta-referral-composite-field" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "meta-referral-composite-label",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t("chat.filterChip.operator")
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: row.operator,
                                      expression: "row.operator",
                                    },
                                  ],
                                  staticClass: "meta-referral-composite-select",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        row,
                                        "operator",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                _vm._l(_vm.operatorOptions, function (option) {
                                  return _c(
                                    "option",
                                    {
                                      key: option.value,
                                      domProps: { value: option.value },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(option.label) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "meta-referral-composite-row-bottom" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "meta-referral-composite-field meta-referral-composite-field--value",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "meta-referral-composite-label",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t("chat.filterChip.value")) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: row.inputValue,
                                    expression: "row.inputValue",
                                  },
                                ],
                                staticClass: "meta-referral-composite-input",
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t(
                                    "chat.filterChip.enterValue"
                                  ),
                                },
                                domProps: { value: row.inputValue },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      row,
                                      "inputValue",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "meta-referral-composite-remove",
                              attrs: {
                                type: "button",
                                disabled: _vm.rows.length <= 1,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.removeRow(index)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("close"),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "meta-referral-composite-add",
                    attrs: { type: "button" },
                    on: { click: _vm.addRow },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("chat.filtersSection.addCondition"))
                      ),
                    ]),
                  ]
                ),
              ],
              2
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }